import { cn } from '@cobliteam/colib-ui/cn';
import { m } from 'motion/react';
import type { HTMLAttributes } from 'react';

interface BlocksIconProps extends HTMLAttributes<HTMLDivElement> {
  size?: number;
  isHovered: boolean;
}

function BlocksIcon({ className, size = 28, isHovered, ...props }: BlocksIconProps) {
  const variant = isHovered ? 'animate' : 'normal';

  return (
    <div className={cn(className)} {...props}>
      <svg
        data-testid='lucide-blocks'
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        {/* The loose block snaps into the corner on hover, like an integration plugging in. */}
        <m.rect
          width='7'
          height='7'
          x='14'
          y='3'
          rx='1'
          transition={{ type: 'spring', stiffness: 250, damping: 15 }}
          variants={{
            normal: { x: 0, y: 0 },
            animate: { x: -3, y: 3 },
          }}
          animate={variant}
        />
        <path d='M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3' />
      </svg>
    </div>
  );
}

export { BlocksIcon };
